(function () {
  'use strict';

  var casesGroups = [
    {
      title: 'IPAD PRO CASES',
      items: [
        ['IPAD PRO 13" (2024)', '/collections/ipad-pro-13-2024-cases'],
        ['IPAD PRO 11" (2024)', '/collections/ipad-pro-11-2024-cases'],
        ['IPAD PRO 12.9" (2022)', '/collections/ipad-pro-12-9-2022-cases'],
        ['IPAD PRO 11" (2022)', '/collections/ipad-pro-11-2020'],
        ['IPAD PRO 12.9" (2021)', '/collections/ipad-pro-12-9-2018-cases'],
        ['IPAD PRO 11" (2021)', '/collections/ipad-pro-11-2021'],
        ['IPAD PRO 12.9" (2020)', '/collections/ipad-pro-12-9-2018-cases'],
        ['IPAD PRO 11" (2020)', '/collections/ipad-pro-11-2020'],
        ['IPAD PRO 12.9" (2018)', '/collections/ipad-pro-12-9-2018-cases'],
        ['IPAD PRO 11" (2018)', '/collections/ipad-pro-11-2020'],
        ['IPAD PRO 10.5" (2017)', '/collections/ipad-pro-10-5-2017']
      ]
    },
    {
      title: 'IPAD CASES',
      items: [
        ['IPAD AIR 13" (2024)', '/collections/ipad-air-13-2024-cases'],
        ['IPAD AIR 11" (2024)', '/collections/ipad-air-5th-gen-2022'],
        ['IPAD 10TH GEN (2022)', '/collections/ipad-10th-gen-10-9-2022-cases'],
        ['IPAD AIR 5 (2022)', '/collections/ipad-air-5th-gen-2022'],
        ['IPAD MINI 6 (2021)', '/collections/ipad-mini-6th-gen-2021-cases'],
        ['IPAD 9TH GEN (2021)', '/collections/ipad-9th-gen-10-2-2021-cases'],
        ['IPAD AIR 4 (2020)', '/collections/ipad-air-4th-gen-2020-cases'],
        ['IPAD 8TH GEN (2020)', '/collections/ipad-8th-gen-10-2-2020-cases'],
        ['IPAD AIR 3 (2019)', '/collections/ipad-air-3-2019'],
        ['IPAD 7TH GEN (2019)', '/collections/ipad-7th-gen-10-2-2019-cases'],
        ['IPAD 6TH GEN (2018)', '/collections/ipad-6th-gen-9-7-2018-cases'],
        ['IPAD 5TH GEN (2017)', '/collections/ipad-5-9-7-2017']
      ]
    },
    {
      title: 'IPHONE 5-12 CASES',
      items: [
        ['IPHONE 12 PRO MAX', '/collections/iphone-12-pro-max-cases'],
        ['IPHONE 12 & 12 PRO', '/collections/iphone-12-12-pro-cases'],
        ['IPHONE 12 MINI', '/collections/iphone-12-mini-cases'],
        ['IPHONE 11 PRO MAX', '/collections/iphone-11-pro-max-cases'],
        ['IPHONE 11 PRO', '/collections/iphone-11-pro-cases'],
        ['IPHONE 11', '/collections/iphone-11-cases'],
        ['IPHONE XR', '/collections/iphone-xr-cases'],
        ['IPHONE XS MAX', '/collections/iphone-xs-max-cases'],
        ['IPHONE X / XS', '/collections/iphone-x-xs-cases'],
        ['IPHONE 7 PLUS / 8 PLUS', '/collections/iphone-7-plus-8-plus-cases'],
        ['IPHONE 7 / 8 / SE2 / SE3', '/collections/iphone-7-8-cases']
      ]
    },
    {
      title: 'IPHONE 13-15 CASES',
      items: [
        ['IPHONE 15 PRO MAX', '/collections/iphone-15-pro-max-cases'],
        ['IPHONE 15 PRO', '/collections/iphone-15-pro-cases'],
        ['IPHONE 15 PLUS', '/collections/iphone-15-plus-cases'],
        ['IPHONE 15', '/collections/iphone-15-cases'],
        ['IPHONE 14 PRO MAX', '/collections/iphone-14-pro-max'],
        ['IPHONE 14 PRO', '/collections/iphone-14-pro-cases'],
        ['IPHONE 14 PLUS', '/collections/iphone-14-plus-cases'],
        ['IPHONE 14', '/collections/iphone-14-cases'],
        ['IPHONE 13 PRO MAX', '/collections/iphone-13-pro-max'],
        ['IPHONE 13 PRO', '/collections/iphone-13-pro'],
        ['IPHONE 13', '/collections/iphone-13'],
        ['IPHONE 13 MINI', '/collections/iphone-13-mini']
      ]
    },
    {
      title: 'IPHONE 16-18 CASES',
      items: [
        ['IPHONE 17 PRO MAX', '/collections/iphone-17-pro-max-cases'],
        ['IPHONE 17 PRO', '/collections/iphone-17-pro-cases'],
        ['IPHONE 17', '/collections/iphone-17-cases'],
        ['IPHONE AIR', '/collections/iphone-air-cases'],
        ['IPHONE 16 PRO MAX', '/collections/iphone-16-pro-max-cases'],
        ['IPHONE 16 PRO', '/collections/iphone-16-pro-cases'],
        ['IPHONE 16 PLUS', '/collections/iphone-16-plus-cases'],
        ['IPHONE 16', '/collections/iphone-16-cases']
      ]
    },
    {
      title: 'SAMSUNG CASES',
      items: [
        ['SAMSUNG S25 ULTRA', '/collections/samsung-s25-ultra-cases'],
        ['SAMSUNG S25 PLUS', '/collections/samsung-s25-plus-cases'],
        ['SAMSUNG S25', '/collections/samsung-s25-cases'],
        ['SAMSUNG S24 FE', '/collections/samsung-s24-fe-cases'],
        ['SAMSUNG S24 ULTRA', '/collections/s24fe'],
        ['SAMSUNG S24 PLUS', '/collections/samsung-s24-plus-cases'],
        ['SAMSUNG S24', '/collections/samsung-s24-cases'],
        ['SAMSUNG S23 FE', '/collections/samsung-s23-fe-cases'],
        ['SAMSUNG A16', '/collections/samsung-a16-cases'],
        ['SAMSUNG A15', '/collections/samsung-a15-cases'],
        ['SAMSUNG A35', '/collections/samsung-a35-cases'],
        ['SAMSUNG A55', '/collections/samsung-a55-cases'],
        ['SAMSUNG A34 5G', '/collections/samsung-a34-5g-cases'],
        ['GOOGLE PIXEL CASES', '/collections/google-pixel-cases']
      ]
    }
  ];

  function buildCasesHtml() {
    var groups = casesGroups.map(function (group, index) {
      return '<button type="button" class="ilab-v2-cases__group' + (index === 0 ? ' is-active' : '') + '" data-ilab-cases-group="' + index + '" aria-controls="ilab-cases-panel-' + index + '" aria-selected="' + (index === 0 ? 'true' : 'false') + '">' +
        '<span>' + group.title + '</span><span class="ilab-v2-cases__arrow" aria-hidden="true"></span></button>';
    }).join('');

    var panels = casesGroups.map(function (group, index) {
      var links = group.items.map(function (item) {
        return '<a href="' + item[1] + '">' + item[0] + '</a>';
      }).join('');

      return '<div id="ilab-cases-panel-' + index + '" class="ilab-v2-cases__panel' + (index === 0 ? ' is-active' : '') + '" data-ilab-cases-panel="' + index + '"' + (index === 0 ? '' : ' hidden') + '>' +
        '<div class="ilab-v2-cases__panel-head"><strong>' + group.title + '</strong><span>Choose your device model</span></div>' +
        '<div class="ilab-v2-cases__model-grid">' + links + '</div></div>';
    }).join('');

    return '<li class="ilab-v2-nav__item">' +
      '<details class="ilab-v2-details ilab-v2-details--cases">' +
      '<summary class="ilab-v2-toplink">CASES &amp; PROTECTION <span class="ilab-v2-chevron" aria-hidden="true"></span></summary>' +
      '<div class="ilab-v2-dropdown ilab-v2-dropdown--cases">' +
      '<div class="ilab-v2-cases__groups"><span class="ilab-v2-dropdown__heading">SHOP BY DEVICE</span>' + groups +
      '<a class="ilab-v2-cases__protection" href="/collections/protection">SCREEN PROTECTION</a></div>' +
      '<div class="ilab-v2-cases__models">' + panels + '</div>' +
      '</div></details></li>';
  }

  var desktopNavHtml = `
    <ul class="ilab-v2-nav" role="list">
      <li class="ilab-v2-nav__item">
        <details class="ilab-v2-details"><summary class="ilab-v2-toplink">PHONES <span class="ilab-v2-chevron" aria-hidden="true"></span></summary><div class="ilab-v2-dropdown"><a href="/collections/iphone">Buy iPhones</a><a href="/collections/samsung-phones">Buy Samsung</a><a href="/collections/buy-google">Buy Google</a></div></details>
      </li>
      <li class="ilab-v2-nav__item">
        <a class="ilab-v2-toplink" href="/collections/second-hand-phones-and-refurbished-ipads">TABLETS</a>
      </li>
      <li class="ilab-v2-nav__item">
        <a class="ilab-v2-toplink" href="/collections/smartwatches">WATCHES</a>
      </li>
      <li class="ilab-v2-nav__item">
        <a class="ilab-v2-toplink" href="/pages/price-request">TRADE-IN</a>
      </li>
      <li class="ilab-v2-nav__item">
        <a class="ilab-v2-toplink" href="/#repair-finder">REPAIRS</a>
      </li>` + buildCasesHtml() + `
      <li class="ilab-v2-nav__item">
        <details class="ilab-v2-details">
          <summary class="ilab-v2-toplink">ACCESSORIES <span class="ilab-v2-chevron" aria-hidden="true"></span></summary>
          <div class="ilab-v2-dropdown ilab-v2-dropdown--accessories">
            <div class="ilab-v2-dropdown__group">
              <span class="ilab-v2-dropdown__heading">Accessories</span>
              <a href="/collections/cables">Cables</a>
              <a href="/collections/chargers">Chargers</a>
              <a href="/collections/adapters">Adapters</a>
              <a href="/collections/power-banks">Power Banks</a>
              <a href="/collections/car-chargers">Car Accessories</a>
              <a href="/collections/cleaning">Cleaning</a>
            </div>
            <div class="ilab-v2-dropdown__group">
              <span class="ilab-v2-dropdown__heading">Audio</span>
              <a href="/collections/on-ear">On-Ear Headphones</a>
              <a href="/collections/in-ear">In-Ear Headphones</a>
              <a href="/collections/portable">Portable Speakers</a>
            </div>
          </div>
        </details>
      </li>
      <li class="ilab-v2-nav__item">
        <details class="ilab-v2-details">
          <summary class="ilab-v2-toplink">MORE <span class="ilab-v2-chevron" aria-hidden="true"></span></summary>
          <div class="ilab-v2-dropdown ilab-v2-dropdown--small ilab-v2-dropdown--right">
            <a href="/pages/how-to-find-us">Contact</a>
            <a href="/blogs/the-ilab-blog">Blog</a>
            <a href="https://g.page/r/CdAOIAtfxt06EB0/review">Leave us a Review</a>
            <a href="/pages/policy">Policies</a>
          </div>
        </details>
      </li>
    </ul>`;

  function ensureCasesStyles() {
    if (document.getElementById('ilab-v2-cases-style')) return;

    var style = document.createElement('style');
    style.id = 'ilab-v2-cases-style';
    style.textContent = `
      @media screen and (min-width:990px) {
        .ilab-v2-dropdown--cases {
          left:auto !important;
          right:-180px !important;
          width:min(900px,calc(100vw - 28px)) !important;
          grid-template-columns:230px minmax(0,1fr) !important;
          gap:0 !important;
          padding:0 !important;
          overflow:hidden !important;
        }
        .ilab-v2-cases__groups {
          padding:12px !important;
          background:#f7f9fb !important;
          border-right:1px solid var(--ilab-nav-line) !important;
        }
        .ilab-v2-cases__group {
          appearance:none !important;
          display:flex !important;
          align-items:center !important;
          justify-content:space-between !important;
          gap:10px !important;
          width:100% !important;
          padding:11px 12px !important;
          margin:1px 0 !important;
          border:0 !important;
          border-radius:9px !important;
          background:transparent !important;
          color:#344054 !important;
          font-family:'Poppins',sans-serif !important;
          font-size:11px !important;
          line-height:1.25 !important;
          font-weight:650 !important;
          letter-spacing:.02em !important;
          text-align:left !important;
          cursor:pointer !important;
        }
        .ilab-v2-cases__group:hover,
        .ilab-v2-cases__group:focus-visible,
        .ilab-v2-cases__group.is-active {
          background:#fff !important;
          color:var(--ilab-nav-blue) !important;
          box-shadow:0 1px 3px rgba(16,24,40,.07) !important;
        }
        .ilab-v2-cases__arrow {
          flex:0 0 auto !important;
          width:7px !important;
          height:7px !important;
          border-top:1.5px solid currentColor !important;
          border-right:1.5px solid currentColor !important;
          transform:rotate(45deg) !important;
          opacity:.65 !important;
        }
        .ilab-v2-cases__protection {
          display:block !important;
          margin-top:8px !important;
          padding:11px 12px !important;
          border-top:1px solid var(--ilab-nav-line) !important;
          border-radius:0 !important;
          color:#263445 !important;
          font-size:11px !important;
          font-weight:700 !important;
          text-decoration:none !important;
        }
        .ilab-v2-cases__protection:hover {
          color:var(--ilab-nav-blue) !important;
        }
        .ilab-v2-cases__models {
          min-width:0 !important;
          padding:22px 24px 24px !important;
          background:#fff !important;
        }
        .ilab-v2-cases__panel[hidden] {
          display:none !important;
        }
        .ilab-v2-cases__panel-head {
          display:flex !important;
          align-items:baseline !important;
          justify-content:space-between !important;
          gap:16px !important;
          padding:0 2px 14px !important;
          border-bottom:1px solid var(--ilab-nav-line) !important;
        }
        .ilab-v2-cases__panel-head strong {
          color:var(--ilab-nav-ink) !important;
          font-family:'Poppins',sans-serif !important;
          font-size:14px !important;
          font-weight:700 !important;
        }
        .ilab-v2-cases__panel-head span {
          color:var(--ilab-nav-muted) !important;
          font-family:'Poppins',sans-serif !important;
          font-size:10.5px !important;
        }
        .ilab-v2-cases__model-grid {
          display:grid !important;
          grid-template-columns:repeat(3,minmax(0,1fr)) !important;
          gap:4px 8px !important;
          padding-top:14px !important;
        }
        .ilab-v2-cases__model-grid a {
          display:block !important;
          padding:9px 10px !important;
          border-radius:8px !important;
          color:#344054 !important;
          font-family:'Poppins',sans-serif !important;
          font-size:10.5px !important;
          line-height:1.25 !important;
          font-weight:500 !important;
          text-decoration:none !important;
        }
        .ilab-v2-cases__model-grid a:hover,
        .ilab-v2-cases__model-grid a:focus-visible {
          background:#f3f8fc !important;
          color:var(--ilab-nav-blue) !important;
        }
      }
      @media screen and (min-width:990px) and (max-width:1180px) {
        .ilab-v2-details--cases > .ilab-v2-toplink {
          padding-left:5px !important;
          padding-right:5px !important;
          font-size:9.8px !important;
        }
        .ilab-v2-dropdown--cases {
          right:-150px !important;
          width:min(860px,calc(100vw - 20px)) !important;
          grid-template-columns:215px minmax(0,1fr) !important;
        }
        .ilab-v2-cases__model-grid {
          grid-template-columns:repeat(2,minmax(0,1fr)) !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function closeAll(except) {
    document.querySelectorAll('.ilab-v2-details[open]').forEach(function (details) {
      if (details !== except) details.removeAttribute('open');
    });
  }

  function bindCasesNav(nav) {
    var details = nav.querySelector('.ilab-v2-details--cases');
    if (!details) return;

    var buttons = details.querySelectorAll('[data-ilab-cases-group]');
    var panels = details.querySelectorAll('[data-ilab-cases-panel]');

    function showPanel(index) {
      buttons.forEach(function (button) {
        var active = button.getAttribute('data-ilab-cases-group') === String(index);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-ilab-cases-panel') === String(index);
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    buttons.forEach(function (button) {
      var index = button.getAttribute('data-ilab-cases-group');
      button.addEventListener('mouseenter', function () { showPanel(index); });
      button.addEventListener('focus', function () { showPanel(index); });
      button.addEventListener('click', function () { showPanel(index); });
    });
  }

  function bindDropdowns(nav) {
    nav.querySelectorAll('.ilab-v2-details').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (details.open) closeAll(details);
      });

      var closeTimer;

      details.addEventListener('mouseenter', function () {
        if (window.matchMedia('(min-width: 990px)').matches) {
          window.clearTimeout(closeTimer);
          closeAll(details);
          details.setAttribute('open', '');
        }
      });

      details.addEventListener('mouseleave', function () {
        if (window.matchMedia('(min-width: 990px)').matches) {
          closeTimer = window.setTimeout(function () {
            if (!details.matches(':hover')) details.removeAttribute('open');
          }, 180);
        }
      });
    });

    bindCasesNav(nav);
  }

  function buildNavigation() {
    var header = document.getElementById('shopify-section-header');
    if (!header) return;

    ensureCasesStyles();

    var desktopNav = header.querySelector('.header__inline-menu');
    if (desktopNav) {
      desktopNav.innerHTML = desktopNavHtml;
      desktopNav.setAttribute('aria-label', 'Main navigation');
      bindDropdowns(desktopNav);
    }

    var icons = header.querySelector('.header__icons');
    if (icons && !icons.querySelector('.ilab-book-repair')) {
      var bookRepair = document.createElement('a');
      bookRepair.className = 'ilab-book-repair';
      bookRepair.href = '/#repair-finder';
      bookRepair.textContent = 'BOOK REPAIR';
      bookRepair.setAttribute('aria-label', 'Book a repair');
      icons.appendChild(bookRepair);
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.ilab-v2-details')) closeAll();
    if (event.target.closest('.ilab-v2-dropdown a')) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildNavigation);
  } else {
    buildNavigation();
  }

  document.addEventListener('shopify:section:load', buildNavigation);
}());
